module.exports = __webpack_public_path__ + "static/media/Rasay.89c4181e.png";